import Store from '@/store'

export default [
  {
    path: '/pendencias/laudos',
    name: 'pendencias-laudos-index',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getPendenciasLaudos')
      next()
    },
    meta: {
      title: 'Laudos para revisão',
      pendenciesFromRoute: 'laudos',
      emptyList: 'Nenhum laudo com pendências foi encontrado.',
      iconList: 'ballot',
      titleText: 'data_coleta',
      subtitleText: 'nome_cliente',
      routeToEdit: 'laudos-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/pendencia')
    }
  },
  {
    path: '/pendencias/visitas/balancetes',
    name: 'pendencias-visitas-balancetes-index',
    beforeEnter: async (to, from, next) => {
      if (Object.keys(to.query).includes('fromTecnico')) {
        await Store.dispatch('getVisitasPendentes', true)
        return next()
      }
      await Store.dispatch('getVisitasPendentes')
      next()
    },
    meta: {
      title: 'Visitas com balancetes não enviados',
      pendenciesFromRoute: 'visitas',
      emptyList: 'Nenhuma visita com pendência de balancete foi encontrada.',
      iconList: 'transfer_within_a_station',
      titleText: 'data_visita',
      subtitleText: 'cliente',
      routeToEdit: 'balancetes-importar-index',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/pendencia')
    }
  }
]
